import React from 'react'
import LoginComponent from './loginComponent'

const LoginModal = () => {
    return (
        <div style={{ zIndex: "20000", position: "fixed", width: "100%", height: "100%", background: "#00000072", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <div style={{ zIndex: "20001", background: "#fff", padding: "50px 30px", borderRadius: "10px" }}>
                <LoginComponent />
            </div>
        </div>
    )
}

export default LoginModal
